var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedLightingAudit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    fill: "#6C5AFC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.583 31.792c0 3.32-1.487 4.923-3.128 8.75-.42.976-3.51 11.15-3.51 11.15H34.639s-2.485-9.725-2.955-10.517C29.707 37.843 28 35.417 28 31.792 28 24.174 34.175 18 41.792 18s13.791 6.175 13.791 13.792z",
    stroke: "#6C5AFC",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.791 51.35V41.4v9.95z",
    fill: "#6C5AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.791 51.35V41.4",
    stroke: "#6C5AFC",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.766 41.4h-9.95 9.95z",
    fill: "#6C5AFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.766 41.4h-9.95",
    stroke: "#6C5AFC",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.592 60.992c0 2.7-3.043 4.889-6.796 4.889-3.754 0-6.796-2.19-6.796-4.89h13.592z",
    stroke: "#6C5AFC",
    strokeWidth: 1.201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.117 57.817l13.35-2.892-13.35 2.892z",
    fill: "#6C5AFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.117 57.817l13.35-2.892",
    stroke: "#6C5AFC",
    strokeWidth: 1.392,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.625 58.725l4.817-.983-4.817.983z",
    fill: "#6C5AFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.625 58.725l4.817-.983",
    stroke: "#6C5AFC",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.142 55l4.816-.983-4.816.983z",
    fill: "#6C5AFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.142 55l4.816-.983",
    stroke: "#6C5AFC",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgLedLightingAudit;